import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IImageWrapper} from '../../models/image-wrapper';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-image-gallery',
  templateUrl: './image-gallery.component.html',
  styleUrls: ['./image-gallery.component.scss']
})
export class ImageGalleryComponent implements OnInit {
  @Input('images') images: IImageWrapper[];
  @Output('select') _selectedImage: EventEmitter<IImageWrapper> = new EventEmitter<IImageWrapper>();

  @Input('card-actions') cardActions: IImageGalleryCardActionsOptions[];
  @Output() singleSelection: EventEmitter<IImageWrapper> = new EventEmitter<IImageWrapper>();
  @Input() multiSelectionEnabled: boolean = false;
  @Input('show-info') showInfo: IImageGalleryShowInfoOptions[];
  
  @Input() public selectedImages : IImageWrapper[] = [];
  @Output() selectedImagesChange: EventEmitter<IImageWrapper[]> = new EventEmitter<IImageWrapper[]>();
  
  constructor() { }

  ngOnInit() {
  }

  /**
   * Executed when an image from the results is selected
   * @param image The selected image
   */
  public onSelect(image: IImageWrapper): void {
    if (!(image instanceof MouseEvent)) {
      this._selectedImage.next(image);
    }
  }

  public toggleImageSelect(image: IImageWrapper){
    // const index = this.selectedImages.findIndex((img) => img.internalId === image.internalId)
    const index = this.selectedImages.indexOf(image)
    if(index > -1){
      this.selectedImages.splice(index,1);
    }else{
      this.selectedImages.push(image)
    }
    console.log(image,{index},this.selectedImages)
    this.selectedImagesChange.emit(this.selectedImages);
  }
  
}

export interface IImageGalleryShowInfoOptions {
  text: string;
  value: (image: IImageWrapper) => string;
  link?: (image: IImageWrapper) => string;
}

export interface IImageGalleryCardActionsOptions<SUBJECT_DATA = any> {
  text: string;
  subject: Subject<SUBJECT_DATA>;
  tooltip?: string;
}
